export const COLOR_GREY = '#F4F4F4'
export const COLOR_BLUE = '#354F7B'
export const COLOR_WHITE = '#FFF'
export const COLOR_BLACK = '#000'
export const COLOR_BLACK_BORDER = '#22222250'
export const COLOR_GREEN = '#5AB7B5'
export const COLOR_BACKGROUND_MENU = '#F7F7F7'
export const COLOR_FOOTER = '#5AB7B5'
export const COLOR_GREY_CITY = '#A0A0A0DB'
export const COLOR_GREY_FORM= '#A8A8A83D'
export const COLOR_GREEN_BUTTON = '#CBECEB'
